module.exports = __webpack_public_path__ + "static/media/bhim.1e3d7d5f.svg";